import styled from '@emotion/styled';
import { BenefitPageUrl } from '../../../constants/header';
import { resetButton } from '../../../styles/reset';
import { sendClickLog } from '../../utils/sendClickLog';

const benefitButtonImageUrl =
  'https://image-cdn.myrealtrip.com/mrt-images-prod/2025/06/19/8hDP/0xPSFlGYTm.webp';

export default function BenefitButton({ link }: { link?: string }) {
  const handleMoveBenefitPage = () => {
    sendClickLog({
      itemKind: 'menu',
      screenName: 'main',
      eventName: 'topmenu',
      itemName: '할인',
    });

    window.location.href = link ?? BenefitPageUrl;
  };

  return (
    <Container type="button" onClick={handleMoveBenefitPage}>
      <BenefitButtonIcon src={benefitButtonImageUrl} />
    </Container>
  );
}

const Container = styled.button`
  ${resetButton};

  padding: 8px 10px;
`;
const BenefitButtonIcon = styled.img`
  height: 28px;
`;
